import React from 'react';
import {TextDisplay} from "./data-display/TextDisplay";
import {Link} from "react-router-dom";
import {RouteConfig} from "../../config/RouteConfig";


export function Footer() {

    return (
        <footer style={{ marginTop: "30px", bottom: "5px", width: 90+"%"}}>
            <TextDisplay align="center" variant="body2">
                <Link to={RouteConfig.about.routes.main.path}>
                    Impressum
                </Link>
            </TextDisplay>
            <div className="flex" style={{ justifyContent: "center", gap: "5px" }}>
                <TextDisplay  variant="body2">
                    {
                        `Copyright © ${ ( new Date().getFullYear() ) } `
                    }
                </TextDisplay>
                <TextDisplay  variant="body2">
                    <a href="https://www.ssnd.de" target="_blank">SSND IT-Service</a>. Alle Rechte vorbehalten.
                </TextDisplay>
            </div>

        </footer>
    );

}